// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"115":"744c0b8e","127":"0e8cb975","154":"4c077aa7","213":"626f4c5b","453":"4b2bfc18","505":"3edd9638","513":"640ab6cd","588":"05e22a0e","627":"ff185c2d","653":"c673b9eb","837":"dc403025","966":"e28e9a0f"}[chunkId] + ".chunk.js";
};